
import { Navigate } from "react-router-dom";
import { NAVIGATION } from "Route/ConstantRoute";

function UnprotectedRoutes({ children }) {
  const isLogin = localStorage.getItem("isLogin");
  if (isLogin && isLogin === "true") {
    return window.location.href = NAVIGATION.intent
    // return <Navigate to={NAVIGATION.intent} />;
  }
  return children;
}

export default UnprotectedRoutes;
